import { render } from "./SearchWidget.vue?vue&type=template&id=02962fca"
import script from "./SearchWidget.js?vue&type=script&lang=js&external"
export * from "./SearchWidget.js?vue&type=script&lang=js&external"

import "./SearchWidget.scss?vue&type=style&index=0&lang=scss&external"
import "./v-popper--theme-search-widget.scss?vue&type=style&index=1&lang=scss&external"

import exportComponent from "../../../../../../../../../.yarn/$$virtual/vue-loader-virtual-29d36d6b67/0/cache/vue-loader-npm-17.3.1-d00a988f1a-cfa887f74c.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"web/themes/custom/hetdepot/dev/js/vue/components/SearchWidget/SearchWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02962fca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02962fca', __exports__)) {
    api.reload('02962fca', __exports__)
  }
  
  module.hot.accept("./SearchWidget.vue?vue&type=template&id=02962fca", () => {
    api.rerender('02962fca', render)
  })

}


export default __exports__